import * as React from 'react';
import { Table } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import { ICurrency } from '../Types';
import { appendCurrencyInfo, addPlusSign, removeMinusSign } from '../ReceivableFunctions';

interface IProps {
    invoicesInvoiced: number;
    invoicesPaid: number;
    invoicesSum: number;
    creditsInvoiced: number;
    creditsPaid: number;
    creditsSum: number;
    totalsInvoiced: number;
    totalsPaid: number;
    totalsSum: number;
    currency: ICurrency;
    site: string;
}

const ReceivableSummary = (props: IProps) => {
    return (
        <fieldset>
            <legend>{Translate('receivable/summary/legend')}</legend>

            <Table responsive className="receivables-summary-table">
                <thead>
                    <tr>
                        <th></th>
                        <th>{Translate('receivable/summary/headers/invoiced')}</th>
                        <th>{Translate('receivable/summary/headers/paid')}</th>
                        <th>{Translate('receivable/summary/headers/outcome')}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{Translate('receivable/summary/row-titles/invoices')}</td>
                        <td>{appendCurrencyInfo(props.currency, props.invoicesInvoiced, true)}</td>
                        <td>{appendCurrencyInfo(props.currency, props.invoicesPaid, true)}</td>
                        <td>
                            {addPlusSign(
                                appendCurrencyInfo(props.currency, props.invoicesSum, true)
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>{Translate('receivable/summary/row-titles/credits')}</td>
                        <td>
                            {removeMinusSign(
                                appendCurrencyInfo(props.currency, props.creditsInvoiced, true)
                            )}
                        </td>
                        <td>{appendCurrencyInfo(props.currency, props.creditsPaid, true)}</td>
                        <td>
                            {addPlusSign(
                                removeMinusSign(
                                    appendCurrencyInfo(props.currency, props.creditsSum, true)
                                )
                            )}
                        </td>
                    </tr>
                    <tr className="last-row">
                        <td>{Translate('receivable/summary/row-titles/sum')}</td>
                        <td>{appendCurrencyInfo(props.currency, props.totalsInvoiced, true)}</td>
                        <td>{appendCurrencyInfo(props.currency, props.totalsPaid, true)}</td>
                        <td>
                            {addPlusSign(appendCurrencyInfo(props.currency, props.totalsSum, true))}
                        </td>
                    </tr>
                </tbody>
            </Table>
        </fieldset>
    );
};

export default ReceivableSummary;
